import { ReqX } from "IZOX/STATIC";
import _ from "lodash";

class VarList {

  /**
   * @typedef {"ClaimType" | "Bank" | "Nationality" 
   * | "ER" | "Diagnosis" | "RR"} optionType
   */

  /**
   * 
   * @param {*[]} list 
   * @param {String} _id 
   * @returns 
   */
  static GetOption(list, _id){
    return _.find(list, o => o._id === _id);
  }

  /**
   * 
   * @param {optionType} optionType 
   */
  static async GetList(optionType){
    let url = this.ListActiveAPI(optionType);
    let res = await ReqX.SendBE(url);
    let {Success, payload} = res;
    if(Success){
      let docs = payload;
      docs = _.orderBy(docs, o => o?.descSeq ?? o.name?.EN);
      return docs;
    }
    return [];
  }

  /**
   * 
   * @param {optionType} optionType 
   */
  static async GetFullList(optionType){
    let url = this.ListAllAPI(optionType);
    let res = await ReqX.SendBE(url);
    let {Success, payload} = res;
    if(Success){
      let docs = payload;
      docs = _.orderBy(docs, o => o?.descSeq ?? o.name?.EN);
      return docs;
    }
    return [];
  }

  /**
   * 
   * @param {optionType} optionType 
   */
  static ListActiveAPI(optionType){
    switch(optionType){
      case "ClaimType": return "/VarList/ClaimType/ListActive";
      case "Bank": return "/VarList/Bank/ListActive";
      case "Nationality": return "/VarList/Nationality/ListActive";
      case "ER":return "/VarList/EndorsementReason/ListActive";
      case "Diagnosis": return "/VarList/Diagnosis/ListActive";
      case "RR": return "/VarList/RejectReason/ListActive";
      default: return "";
    }
  }

  /**
   * 
   * @param {optionType} optionType 
   */
  static ListAllAPI(optionType){
    switch(optionType){
      case "ClaimType": return "/VarList/ClaimType/List";
      case "Bank": return "/VarList/Bank/List";
      case "Nationality": return "/VarList/Nationality/List";
      case "ER": return "/VarList/EndorsementReason/List";
      case "Diagnosis": return "/VarList/Diagnosis/List";
      case "RR": return "/VarList/RejectReason/List";
      default: return "";
    }
  }

  /**
   * 
   * @param {optionType} optionType 
   */
  static GetAPI(optionType){
    switch(optionType){
      case "ClaimType": return "/VarList/ClaimType/Get";
      case "Bank": return "/VarList/Bank/Get";
      case "Nationality": return "/VarList/Nationality/Get";
      case "ER": return "/VarList/EndorsementReason/Get";
      case "Diagnosis": return "/VarList/Diagnosis/Get";
      case "RR": return "/VarList/RejectReason/Get";
      default: return "";
    }
  }

  /**
   * 
   * @param {optionType} optionType 
   */
  static AddAPI(optionType){
    switch(optionType){
      case "ClaimType": return "/VarList/ClaimType/Add";
      case "Bank": return "/VarList/Bank/Add";
      case "Nationality": return "/VarList/Nationality/Add";
      case "ER": return "/VarList/EndorsementReason/Add";
      case "Diagnosis": return "/VarList/Diagnosis/Add";
      case "RR": return "/VarList/RejectReason/Add";
      default: return "";
    }
  }

  /**
   * 
   * @param {optionType} optionType 
   */
  static EditAPI(optionType){
    switch(optionType){
      case "ClaimType": return "/VarList/ClaimType/Edit";
      case "Bank": return "/VarList/Bank/Edit";
      case "Nationality": return "/VarList/Nationality/Edit";
      case "ER": return "/VarList/EndorsementReason/Edit";
      case "Diagnosis": return "/VarList/Diagnosis/Edit";
      case "RR": return "/VarList/RejectReason/Edit";
      default: return "";
    }
  }

  /**
   * 
   * @param {optionType} optionType 
   */
  static SetActiveAPI(optionType){
    switch(optionType){
      case "ClaimType": return "/VarList/ClaimType/SetActive";
      case "Bank": return "/VarList/Bank/SetActive";
      case "Nationality": return "/VarList/Nationality/SetActive";
      case "ER": return "/VarList/EndorsementReason/SetActive";
      case "Diagnosis": return "/VarList/Diagnosis/SetActive";
      case "RR": return "/VarList/RejectReason/SetActive";
      default: return "";
    }
  }

}

export default VarList;